<template>
  <div class="plm">
    <div class="plm-head">
      <button type="button" class="plm-back" @click="goBack"><i>‹</i>返回</button>
      <h1>我的下载</h1>
      <p class="plm-sub">
        <span>{{ title || '本相册' }}</span>
        <template v-if="total">
          <span class="plm-sub__sep">·</span>
          <span>{{ total }} 张</span>
        </template>
      </p>
    </div>

    <div v-if="err" class="plm-empty">
      <p class="plm-empty__text">{{ err }}</p>
      <button type="button" class="plm-empty__btn" @click="goBack">返回相册</button>
    </div>
    <div v-else-if="loading && !photos.length" class="plm-grid plm-grid--sk">
      <div v-for="i in 9" :key="'sk' + i" class="plm-cell plm-cell--sk" />
    </div>
    <div v-else-if="!photos.length" class="plm-empty">
      <div class="plm-empty__ring"><i /></div>
      <p class="plm-empty__text">还没有下载过照片</p>
      <p class="plm-empty__tip">在相册里长按照片，或点「多选」批量下载</p>
      <button type="button" class="plm-empty__btn" @click="goBack">去相册看看</button>
    </div>

    <div v-else class="plm-grid">
      <div v-for="p in photos" :key="p.id" class="plm-cell" @click="preview(p)">
        <img :src="p.thumbUrl || p.displayUrl" alt="" />
      </div>
    </div>

    <button v-if="hasMore && photos.length" type="button" class="plm-more" :disabled="loading" @click="loadMore">
      {{ loading ? '加载中…' : '加载更多' }}
    </button>

    <div v-if="viewUrl" class="plm-view" @click="viewUrl = ''">
      <img :src="viewUrl" alt="" />
      <p>长按图片保存到相册 · 点击空白关闭</p>
    </div>
  </div>
</template>

<script>
import { getPhotoLiveAlbum, getPhotoLiveMine, getPhotoLiveUid } from '@/api/photoLive'

export default {
  name: 'PhotoLiveMine',
  data() {
    return {
      albumCode: '',
      title: '',
      uid: '',
      photos: [],
      page: 0,
      total: 0,
      loading: false,
      err: '',
      viewUrl: ''
    }
  },
  computed: {
    hasMore() {
      return this.photos.length < this.total
    }
  },
  created() {
    this.albumCode = this.$route.params.albumCode || ''
    this.uid = getPhotoLiveUid()
    if (!this.albumCode) {
      this.err = '缺少相册'
      return
    }
    getPhotoLiveAlbum(this.albumCode).then(a => {
      this.title = (a && a.title) || ''
    }).catch(() => {})
    this.loadMore()
  },
  methods: {
    async loadMore() {
      if (this.loading) return
      this.loading = true
      try {
        const res = await getPhotoLiveMine(this.albumCode, this.uid, this.page, 40)
        const list = (res && res.content) || []
        this.total = (res && res.totalElements) || list.length
        this.photos = this.photos.concat(list)
        this.page += 1
      } catch (e) {
        this.err = (e && (e.msg || e.message)) || '加载失败'
      } finally {
        this.loading = false
      }
    },
    goBack() {
      // 返回到相册页并跳过封面（用 replace 避免历史栈里多出一层）
      this.$router.replace({
        name: 'PhotoLiveAlbum',
        params: { albumCode: this.albumCode },
        query: { skipCover: 1 }
      })
    },
    preview(p) {
      // 微信内跳转外部图片会弹「无法确认本次跳转是否安全」，改为页内查看
      this.viewUrl = p.displayUrl || p.thumbUrl || ''
    }
  }
}
</script>

<style scoped>
/* px 按 750 设计宽书写，构建时自动转 vw */
.plm { min-height: 100vh; background: #f7f5f2; padding-bottom: 60px; }

.plm-head {
  position: relative; text-align: center;
  padding: 48px 32px 32px;
  background: linear-gradient(180deg, #f1e9df 0%, #f7f5f2 100%);
}
.plm-back {
  position: absolute; left: 28px; top: 44px;
  display: inline-flex; align-items: center; gap: 6px;
  height: 64px; padding: 0 26px 0 18px;
  border: 1px solid #e6dccf; border-radius: 999px;
  background: rgba(255,255,255,.85); color: #8a6b42; font-size: 26px;
  box-shadow: 0 6px 16px rgba(70,45,25,.08);
}
.plm-back i {
  font-style: normal; font-size: 36px; line-height: 1; margin-top: -4px; color: #b08b57;
}
.plm-head h1 {
  margin: 0; font-size: 44px; line-height: 1.25; color: #1f1a17;
  font-weight: 700; letter-spacing: 2px;
  font-family: "Songti SC", "Noto Serif CJK SC", "STSong", serif;
}
.plm-sub {
  display: flex; align-items: center; justify-content: center; gap: 10px;
  margin: 14px 0 0; color: #9c9188; font-size: 24px;
}
.plm-sub__sep { color: #d8cfc6; }

.plm-grid {
  display: grid; grid-template-columns: repeat(3, 1fr); gap: 14px; padding: 24px;
}
.plm-cell {
  position: relative; padding-top: 100%; border-radius: 20px; overflow: hidden;
  background: #efe8e1; box-shadow: 0 6px 18px rgba(70,45,25,.08);
  animation: plmIn .3s ease both;
}
@keyframes plmIn { from { opacity: 0; transform: translateY(16px); } to { opacity: 1; transform: none; } }
.plm-cell img {
  position: absolute; inset: 0; width: 100%; height: 100%; object-fit: cover;
}
.plm-cell--sk { box-shadow: none; }
.plm-cell--sk::after {
  content: ''; position: absolute; inset: 0;
  background: linear-gradient(100deg, rgba(255,255,255,0) 15%, rgba(255,255,255,.75) 50%, rgba(255,255,255,0) 85%);
  transform: translateX(-100%);
  animation: plmShine 1.8s ease-in-out infinite;
}
.plm-cell--sk:nth-child(3n+2)::after { animation-delay: .35s; }
.plm-cell--sk:nth-child(3n)::after { animation-delay: .7s; }
@keyframes plmShine { 0% { transform: translateX(-100%); } 100% { transform: translateX(100%); } }

.plm-empty { padding: 120px 48px 0; text-align: center; }
.plm-empty__ring {
  width: 140px; height: 140px; margin: 0 auto 36px;
  border: 2px solid #e0d3bf; border-radius: 50%;
  display: flex; align-items: center; justify-content: center;
}
.plm-empty__ring i {
  width: 18px; height: 18px; border-radius: 50%; background: #c7a06a;
  animation: plmPulse 1.6s ease-in-out infinite;
}
@keyframes plmPulse { 0%, 100% { opacity: .25; transform: scale(.8); } 50% { opacity: 1; transform: scale(1); } }
.plm-empty__text { margin: 0; color: #8f857c; font-size: 30px; }
.plm-empty__tip { margin: 14px 0 0; color: #b1a79d; font-size: 24px; }
.plm-empty__btn {
  margin-top: 40px; height: 88px; padding: 0 56px; border: 0; border-radius: 999px;
  background: linear-gradient(135deg, #cbab7d, #a97f4e);
  color: #fff; font-size: 28px; letter-spacing: 2px;
  box-shadow: 0 10px 24px rgba(120,85,45,.3);
}

.plm-more {
  display: block; margin: 28px auto; height: 72px; padding: 0 44px;
  border: 1px solid #e6dccf; border-radius: 999px;
  background: rgba(255,255,255,.85); color: #8a6b42; font-size: 26px;
}

.plm-view {
  position: fixed; inset: 0; z-index: 60;
  display: flex; flex-direction: column; align-items: center; justify-content: center;
  padding: 40px 32px calc(40px + env(safe-area-inset-bottom));
  box-sizing: border-box; background: rgba(20,14,8,.94);
}
.plm-view img { max-width: 100%; max-height: 78vh; border-radius: 20px; object-fit: contain; }
.plm-view p { margin: 28px 0 0; color: rgba(255,255,255,.6); font-size: 24px; }
</style>
